const all = ['prescriptionTemplates']
const lists = [...all, 'list']
const list = (drugIds: Array<number>) => [...lists, drugIds]

export const prescriptionTemplateKeys = {
  all,
  lists,
  list,
}
